import { Skeleton } from "@/shared/ui";

export default function HiringCardsSkeleton() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-4">
      {Array.from({ length: 8 }).map((_, index) => (
        <div key={index} className="flex flex-col gap-4 surface-component-fill radius-lg p-5">
          <div className="flex flex-col gap-2">
            <Skeleton width={120} height={24} borderRadius={6} />
            <Skeleton width={180} height={20} />
          </div>

          <div className="flex flex-col border-b surface-base-stroke py-3 gap-3">
            <div className="flex items-center gap-1.5">
              <Skeleton width={18} height={18} borderRadius={4} />
              <Skeleton width={160} height={14} />
            </div>
            <div className="flex items-center gap-1.5">
              <Skeleton width={18} height={18} borderRadius={4} />
              <Skeleton width={120} height={14} />
            </div>
            <div className="flex items-center gap-1.5">
              <Skeleton width={18} height={18} borderRadius={4} />
              <Skeleton width={140} height={14} />
            </div>
          </div>

          <div className="flex flex-col pt-3 gap-1.5">
            <Skeleton width={100} height={12} />
            <div className="flex items-center gap-1.5">
              <Skeleton width={18} height={18} borderRadius={4} />
              <Skeleton width={120} height={14} />
            </div>
          </div>

          <Skeleton width="100%" height={36} borderRadius={12} />
        </div>
      ))}
    </div>
  );
}
